import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// API URLs
const BASE_URL = 'https://onboard.rechargkit.biz/member';
// Async thunk for PAN verification
export const panVerify = createAsyncThunk(
  'verify/panVerify',
  async ({ member_id, pan_no, token }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/panVerify`,
        { member_id, pan_no },
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'PAN verification failed');
    }
  }
);

// Async thunk for Aadhar verification
export const aadharVerify = createAsyncThunk(
  'verify/aadharVerify',
  async ({ member_id, aadhar_no, token }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/aadharVerify`,
        { member_id, aadhar_no },
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Aadhar verification failed');
    }
  }
);

// Async thunk for Bank verification
export const bankVerify = createAsyncThunk(
  'verify/bankVerify',
  async ({ member_id, account_no, ifsc, token }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/bankVerify`,
        { member_id, account_no, ifsc },
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Bank verification failed');
    }
  }
);

const memberVerifySlice = createSlice({
  name: 'verify',
  initialState: {
    panStatus: null,
    aadharStatus: null,
    bankStatus: null,
    loading: false,
    error: null,
  },
  reducers: {
    resetVerifyState: (state) => {
      state.panStatus = null;
      state.aadharStatus = null;
      state.bankStatus = null;
      state.loading = false;
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      // PAN Verify
      .addCase(panVerify.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(panVerify.fulfilled, (state, action) => {
        state.loading = false;
        state.panStatus = action.payload;
      })
      .addCase(panVerify.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Aadhar Verify
      .addCase(aadharVerify.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(aadharVerify.fulfilled, (state, action) => {
        state.loading = false;
        state.aadharStatus = action.payload;
      })
      .addCase(aadharVerify.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Bank Verify
      .addCase(bankVerify.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(bankVerify.fulfilled, (state, action) => {
        state.loading = false;
        state.bankStatus = action.payload;
      })
      .addCase(bankVerify.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetVerifyState } = memberVerifySlice.actions;

export default memberVerifySlice.reducer;
